<label class="switch" [ngClass]="{'disable' : disabled}">
  <input type="checkbox" [checked]="value" tabindex="1" [value]="value" [id]="id" (click)="switch()">
  <span class="slider round"></span>
</label>